import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BenefitsDetail} from '../../../models/benefits.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-rent-benefits',
  templateUrl: './rent-benefits.component.html',
  styleUrls: ['./rent-benefits.component.scss']
})
export class RentBenefitsComponent implements OnInit {
  @Input() itemsCoreData: { activeItems: BenefitsDetail[], noActiveItems: BenefitsDetail[] };
  @Input() mantenienceSection;
  @Output() itemAvailability: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemCreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemEdit: EventEmitter<any> = new EventEmitter<any>();

  class: string | null = null;

  constructor() {
  }

  ngOnInit(): void {

  }

  sendItemAvailability(itemId: number): void {
    this.itemAvailability.emit(itemId);
  }

  sendItemCreate(): void {
    this.itemCreate.emit(true);
  }

  sendItemEdit(item: any): void {
    this.itemEdit.emit(item);
  }

  sendItemDelete(itemId: number) {
    this.itemDelete.emit(itemId);
  }
}
